
import { CrudProdCommandAction, prodCommandActionType } from '../actions/prod-command.action';
import { ProdCommand } from '../models/prodCommand.model';
import { element } from 'protractor';
//create a dummy initial state
const initialState: ProdCommand[][] = [];
export function prodCommandReducer(state: ProdCommand[][] = initialState,action: CrudProdCommandAction) {
  switch (action.type) {
    case prodCommandActionType.SAVE_PRODCOMMAND:

      state=Object.assign([],state)
      state[action.payload.table]=Object.assign([],state[action.payload.table])
      state[action.payload.table].push(action.payload.prod)
      return {
        ...state
      };
    case prodCommandActionType.UPLOAD_PRODCOMMAND:
      
      state=Object.assign([],state)
      if(action.payload.res==undefined)
        {
          let dataFromBack=Object.assign([],action.payload)
          state=Object.assign([],state)
          let productsFromBack;
          dataFromBack.map(data=>{
            // Conserver uniquement les produits status 'new' (ajoutés localement par le serveur)
            // 'pending' vient toujours du backend → ne jamais le dupliquer
            const currentNewPendingProducts = state[data.table] ?
              state[data.table].filter(p => p.status === 'new') : [];

            state[data.table]=Object.assign([],state[data.table])
            productsFromBack=Object.assign([],data.prods)

            // Merger : produits du backend + produits new/pending locaux
            state[data.table] = [...productsFromBack, ...currentNewPendingProducts]


          })
        }

      return {
        ...state
      };
    case prodCommandActionType.REMOVE_PRODCOMMAND:

      state=Object.assign([],state)
      state[action.payload.table]=Object.assign([],state[action.payload.table])
      var filtered = state[action.payload.table].filter(function(value, index, arr){
        return index!=action.payload.key;
      })
      state[action.payload.table]=null;
      state[action.payload.table]=filtered;
      state=Object.assign({},state);
      return {
        ...state
      };
    case prodCommandActionType.ADDONE_PRODCOMMAND:

      state=Object.assign([],state)
      state[action.payload.table]=Object.assign([],state[action.payload.table])



      for(let i=0;i<state[action.payload.table].length;i++)
        {
          // Modifier uniquement les produits avec statut 'new' ou 'pending'
          if(state[action.payload.table][i].product.id==action.payload.product &&
             (state[action.payload.table][i].status === 'new' || state[action.payload.table][i].status === 'pending'))
          {
              state[action.payload.table][i]=Object.assign([],state[action.payload.table][i]);
              state[action.payload.table][i]['count']++;
              state[action.payload.table][i]['price']=state[action.payload.table][i].price;
              state[action.payload.table][i]=Object.assign({},state[action.payload.table][i]);
              break; // Sortir après avoir trouvé et modifié le premier produit correspondant
          }
        }

        state=Object.assign({},state);
      return {
        ...state
      };
    case prodCommandActionType.REMOVEONE_PRODCOMMAND:

      state=Object.assign([],state)
      state[action.payload.table]=Object.assign([],state[action.payload.table])
      for(let i=0;i<state[action.payload.table].length;i++)
        {
          // Modifier uniquement les produits avec statut 'new' ou 'pending'
          if(state[action.payload.table][i].product.id==action.payload.product &&
             (state[action.payload.table][i].status === 'new' || state[action.payload.table][i].status === 'pending'))
          {
              state[action.payload.table][i]=Object.assign([],state[action.payload.table][i]);
              state[action.payload.table][i]['count']--;
              state[action.payload.table][i]['price']=state[action.payload.table][i].price;
              state[action.payload.table][i]=Object.assign({},state[action.payload.table][i]);
              break; // Sortir après avoir trouvé et modifié le premier produit correspondant
          }
        }
        state=Object.assign({},state);
      return {
        ...state
      };
    case prodCommandActionType.RESET_PRODCOMMAND:

      state=Object.assign([],state)
      state[action.payload.table]=Object.assign([],state[action.payload.table])
      state[action.payload.table]=[]

      return {
        ...state
      };
    case prodCommandActionType.ACCEPT_ALL_PRODCOMMAND:
      console.log(action.payload)
  state = Object.assign([], state)
  state[action.payload.table] = Object.assign([], state[action.payload.table])

  for(let i=0;i<state[action.payload.table].length;i++)
  {
    let prod = state[action.payload.table][i];

    if(prod.status === 'new' || prod.status === 'pending') {

     
      state[action.payload.table][i] = {
        ...prod,
        status: 'accepted',
        price: prod.gratuit ? 0 : prod.product.price // ✅ FIX ICI
      };
    }
  }

  return {
    ...state
  };
    case prodCommandActionType.REPLACE_ALL_PRODCOMMAND:
      state = Object.assign([], state);
      state[action.payload.table] = [...action.payload.products];
      return { ...state };
    default:
      return state;
  }
}
